import { BarChart, Bar, XAxis, YAxis, CartesianGrid, Tooltip, Legend, ResponsiveContainer } from "recharts";

const barColor = (i, total) => `hsl(${Math.round((i * 360) / Math.max(total, 1))}, 62%, 48%)`;

export function SopStatsChart({ stats }) {
  if (!stats || stats.years.length === 0) return null;
  const data = stats.years.map((year) => {
    const row = { year };
    stats.sites.forEach((site) => {
      row[site] = stats.matrix[site]?.[year] || 0;
    });
    return row;
  });

  return (
    <div className="h-72" data-testid="sop-stats-chart">
      <ResponsiveContainer width="100%" height="100%">
        <BarChart data={data} margin={{ top: 8, right: 8, left: 0, bottom: 0 }}>
          <CartesianGrid strokeDasharray="3 3" vertical={false} stroke="hsl(var(--border))" />
          <XAxis dataKey="year" tick={{ fontSize: 12 }} stroke="hsl(var(--muted-foreground))" />
          <YAxis tick={{ fontSize: 12 }} stroke="hsl(var(--muted-foreground))" allowDecimals={false} />
          <Tooltip
            contentStyle={{
              background: "hsl(var(--card))",
              border: "1px solid hsl(var(--border))",
              borderRadius: 8,
              fontSize: 12,
            }}
          />
          <Legend wrapperStyle={{ fontSize: 11 }} />
          {stats.sites.map((site, i) => (
            <Bar key={site} dataKey={site} stackId="sites" fill={barColor(i, stats.sites.length)} />
          ))}
        </BarChart>
      </ResponsiveContainer>
    </div>
  );
}
